# Option 2: GraphQL user experience guide

As part of this revision,
GraphQL implementations of ad selection must adhere to new user experience requirements.

The file below contains an example of a compliant user experience as well as examples that no longer meet the requirements.

import { PdfFile } from './PdfFile';

<PdfFile />

Once you are familiar with these requirements,
continue to the [GraphQL implementation guide].

[GraphQL implementation guide]: /use-cases/job-posting/ad-selection/v2/graphql
